import { Controller } from "@hotwired/stimulus"

// Fecha o modal de detalhe de notificação ao conectar E dispara um toast de
// feedback. Injetado por um turbo_stream (ex.: após remover a notificação de
// DENTRO do modal) — assim a ação dá feedback (fecha + toast), em vez de deixar
// o modal aberto e vazio. Fechar é no-op se o modal já estiver fechado (remover
// direto da lista). O elemento se auto-remove depois de agir.
//
//   <%= turbo_stream.append "notification-detail-modal" do %>
//     <div data-controller="dismiss-notification-modal"
//          data-dismiss-notification-modal-message-value="<%= t('...') %>" hidden></div>
//   <% end %>
export default class extends Controller {
  static values = { message: String, variant: { type: String, default: "success" } }

  connect() {
    const modal = document.getElementById("notification-detail-modal")
    const ctrl =
      modal && window.Stimulus &&
      window.Stimulus.getControllerForElementAndIdentifier(modal, "dialog")
    // close() (com animação) se o modal está aberto; se já fechado (remoção veio
    // da lista, não do modal), closeNow() evita esperar o fallback da animação.
    if (ctrl) {
      modal.classList.contains("hidden") ? ctrl.closeNow() : ctrl.close()
    }

    if (this.messageValue) {
      document.dispatchEvent(new CustomEvent("toast", {
        detail: { message: this.messageValue, variant: this.variantValue }
      }))
    }
    this.element.remove()
  }
}
